import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { notesFiltersInitialValues } from '../../../screens/NotesPage/Filters';
import { NotesState } from '../models/NotesState';

const initialNotesState: NotesState = {
  conversationDocumentMetadata: null,
  conversations: [],
  currentConversation: null,
  currentConversationMessages: [],
  filters: notesFiltersInitialValues,
  intent: { type: 'READ', conversationId: null },
  isSendingMessage: false,
  isFetchingConversationsLoading: false,
  lastConversationFetchError: null,
};

export const notesSlice = createSlice({
  name: 'notes',
  initialState: initialNotesState,
  selectors: {
    selectConversations: (state: NotesState) => {
      return state.conversations;
    },
  },
  reducers: {
    setConversationDocumentMetadata(state, action: PayloadAction<NotesState['conversationDocumentMetadata']>) {
      state.conversationDocumentMetadata = action.payload;
    },
    setConversations(state, action: PayloadAction<NotesState['conversations']>) {
      state.conversations = action.payload;
    },
    setCurrentConversation(state, action: PayloadAction<NotesState['currentConversation']>) {
      state.currentConversation = action.payload;
    },
    setCurrentConversationMessages(state, action: PayloadAction<NotesState['currentConversationMessages']>) {
      state.currentConversationMessages = action.payload;
    },
    setFilters(state, action: PayloadAction<NotesState['filters']>) {
      state.filters = action.payload;
    },
    setIntent(state, action: PayloadAction<NotesState['intent']>) {
      state.intent = action.payload;
    },
    setIsSendingMessage(state, action: PayloadAction<boolean>) {
      state.isSendingMessage = action.payload;
    },
    setIsFetchingConversationsLoading(state, action: PayloadAction<boolean>) {
      state.isFetchingConversationsLoading = action.payload;
    },
    setLastConversationFetchError(state, action: PayloadAction<string | null>) {
      state.lastConversationFetchError = action.payload;
    },
    resetNotes() {
      return initialNotesState;
    },
    unloadCurrentConversation(state) {
      return {
        ...state,
        conversationDocumentMetadata: null,
        currentConversation: null,
        currentConversationMessages: [],
      };
    },
  },
});

export const {
  setConversations,
  setCurrentConversation,
  setCurrentConversationMessages,
  setFilters,
  setIntent,
  resetNotes,
  setIsSendingMessage,
  setIsFetchingConversationsLoading,
  setConversationDocumentMetadata,
  unloadCurrentConversation,
  setLastConversationFetchError,
} = notesSlice.actions;

export const notesSelectors = notesSlice.selectors;
export const notesReducer = notesSlice.reducer;
